export default __webpack_public_path__ + "static/media/012-stove.72084a73.svg";